import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CompanyLogoSkeleton = () => {
  return (
    <div className="d-flex justify-content-start ml-3 align-items-center">
      <div className="d-flex align-items-center">
        <div className="baseSkeleton bg-secondary" style={{ width: "24px", height: "24px", marginTop: "10px", marginRight:"10px" }}></div>
        <div className="baseSkeleton rounded-circle bg-secondary" style={{ width: "24px", height: "24px", marginTop: "10px" }}></div>

        <div className="flex-grow-1 ms-2 d-flex align-items-center">
          <div className="baseSkeleton bg-secondary rounded mt-2" style={{ height: "20px", width: "100px" }}></div>
        </div>
      </div>
    </div>
  );
};

export default CompanyLogoSkeleton;
